<div class="book-now-container">
    <div class="btn-container">
        <button (click)="navigateToSquareUp()">Book online</button>
    </div>
    
    <div class="btn-container">
        <button class="btn-ghost" (click)="shopOnline()">Shop online</button>
    </div>
</div>
